import http from "./http";
import {useRequest} from "ahooks";
import {config} from "../utils";
import cookies from "../utils/cookies";

let apiPath = {
  delCollect: '/item/prodItemCollect/delCollect',
  saveCollect: '/item/prodItemCollect/saveCollect',
  qryCollectPage: '/item/prodItemCollect/qryCollectPage',
};


export const useQryCollectPage = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.qryCollectPage,
      method: 'get',
      data: q || {},
    }, { noAlias: true, noAgent: true });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    getList: runAsync
  };
};

/**
 * 添加收藏
 * @returns {{result: unknown, loading: boolean, error: Error, addWishHandle: (...params: any[]) => Promise<unknown>}}
 */
export const useSaveCollect = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.saveCollect,
      method: 'post',
      data: q,
    }, { noAlias: true, json: true, });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    addWishHandle: runAsync
  };
};

export const useDelCollect = () => {
  const { data, runAsync, error, loading } = useRequest((q) => {
    
    return http({
      url: apiPath.delCollect,
      method: 'post',
      data: q,
    }, { noAlias: true, noAgent: true, });
  }, {
    manual: true,
  });
  
  return {
    result: data,
    loading,
    error,
    delWishHandle: runAsync
  };
};
